import FrameworkCourseController from "../../../framework-course.controller";

class Diagram5Controller extends FrameworkCourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';
    super(courseService, diagramService, $translate, $timeout, $scope);
    this.isFiveSection = true
    this.amountCorrectAnswers = 5;
    this.exerciseId = 'exercise-3';
    this.clearDiagramId = 3
    this.pyramidData = {
      exerciseNumber: 3,
      scheme: {
        model: {
          textarea: 'They will be focusing on how to make it easier for customers and mfrs. to do business with C&S at every level',
        },
        children: [
          {
            model: {
              textarea: 'Improve working relationships with manufacturers',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Ensure S&G points of contact are communicated to the vendor/broker community',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Provide effective cate-gory management and marketing solutions to both customers and manufacturers',
            },
            children: [

            ]
          },
          {
            model: {
              textarea: 'Tie our merchandising programs directly to customer performance',
            },
            children: [

            ]
          },
        ],
      },
      instruction: `<p>You are now ready to determine the appropriate Situation, Complication, and Question for the pyramid below. I have indicated the areas in the problem definition from which the information for each part of the introduction can be found.</p>
                    <ol>
                     <li>Situation = Sit</li>
                     <li>Disturbing Event = DE</li>
                     <li>Result 1 = R1</li>
                     <li>Result 2 = R2</li>
                     <li>Solution = Sol</li>
                    </ol>
                    <p>What you want to do now is make a 1 or 2 sentence summary of the essence of what it will say. Once you have done that and pressed Complete, you can take a look at the full introduction I would have written.</p>`,
      scq: {
        's-header': 'DE, R1',
        'c-header': 'Sol, R2'
      },
      // additionalBox: 'SUGGESTED STRUCTURE 2014 ADVANTAGE SURVEY RESULTS AND ACTION PLAN',
      opacity: 0.5,
    };
  }
}

export default Diagram5Controller;



// WEBPACK FOOTER //
// ./client/app/components/diagrams/5/5b/diagram5/diagram5.controller.js